document.addEventListener('DOMContentLoaded', function () {
  const qtyInput = document.getElementById('dev_take-mattress-pdp-qty-input');
  const minusBtn = document.querySelector('.mattress-pdp-qty-minus');
  const plusBtn = document.querySelector('.mattress-pdp-qty-plus');
  const addToCartBtns = document.querySelectorAll('.mattress-pdp-form-wrap .mattress-pdp-atc-btn, .sticky-stc-mobile-wrap .mattress-pdp-atc-btn');
  const lengthInputElem = document.getElementById('lengthInput');
  const breadthInputElem = document.getElementById('breadthInput');
  const dimensionErrorWrp = document.querySelector('.dimension-error-wrap');
  const errorMessgageElem = document.getElementById('dimension-error');

  // Check for preserved options from URL parameters
  const urlParams = new URLSearchParams(window.location.search);
  const preservedCategory = urlParams.get('category');
  const preservedHeight = urlParams.get('height');
  const preservedSize = urlParams.get('size');
  const preservedCustomLength = urlParams.get('custom_length');
  const preservedCustomBreadth = urlParams.get('custom_breadth');
  const preservedUnit = urlParams.get('unit') || urlParams.get('size_unit');

  const variantWrapper = document.querySelector(".pv-pdp-variant-wrapper");
  
  const categoryGroupName = "option-category";
  const sizeGroupName = "option-size";
  const heightGroupName = "option-height";

  const categoryInputs = variantWrapper.querySelectorAll(`input[name="${categoryGroupName}"]`);
  const sizeInputs = variantWrapper.querySelectorAll(`input[name="${sizeGroupName}"]`);
  const heightInputs = variantWrapper.querySelectorAll(`input[name="${heightGroupName}"]`);
  
  let minLength = Infinity;
  let maxLength = -Infinity;
  let minBreadth = Infinity;
  let maxBreadth = -Infinity;


  // Reusable validation function
function validateUptoOneDecimal(inputElem) {
  inputElem.addEventListener("input", () => {
    let value = inputElem.value;

    if (value === "") return;

    // Match numbers with up to 1 decimal place - allow more digits for larger values (e.g., centimeters)
    // Allows: 0-999.9 (for inches/feet) or 0-9999.9 (for centimeters)
    const regex = /^\d{1,4}(?:\.\d{0,1})?$/;

    if (!regex.test(value)) {
      inputElem.value = value.slice(0, -1);
    }
  });
}
// Apply to both fields
validateUptoOneDecimal(lengthInputElem);
validateUptoOneDecimal(breadthInputElem);

  function calculateMinMaxDimensions() {
    minLength = Infinity;
    maxLength = -Infinity;
    minBreadth = Infinity;
    maxBreadth = -Infinity;
    
    // Wait for customProductVariants to be available
    const variantsToUse = (window.customProductVariants || customProductVariants || []);
    
    if (!variantsToUse || variantsToUse.length === 0) {
      // Variants not loaded yet, retry after a delay
      setTimeout(calculateMinMaxDimensions, 200);
      return;
    }
    
    variantsToUse.forEach(variant => {
      const sizeOption = variant.option3;
      if (!sizeOption) return;
      
      const sizeParts = sizeOption.match(/(\d+(?:\.\d+)?)\s*"\s*x\s*(\d+(?:\.\d+)?)\s*"/);
      if (!sizeParts) return;
      
      const length = parseFloat(sizeParts[1]);
      const breadth = parseFloat(sizeParts[2]);
      
      if (!isNaN(length)) {
        minLength = Math.min(minLength, length);
        maxLength = Math.max(maxLength, length);
      }
      
      if (!isNaN(breadth)) {
        minBreadth = Math.min(minBreadth, breadth);
        maxBreadth = Math.max(maxBreadth, breadth);
      }
    });
    
    console.log(`Custom Variants - Length: Min = ${minLength}, Max = ${maxLength}`);
    console.log(`Custom Variants - Breadth: Min = ${minBreadth}, Max = ${maxBreadth}`);
  }

  // Wait for variant data to be available before calculating
  function waitForVariantsAndCalculate() {
    if (window.customProductVariants || (typeof customProductVariants !== 'undefined' && customProductVariants)) {
      calculateMinMaxDimensions();
    } else {
      // Retry after 200ms if variants not loaded yet
      setTimeout(waitForVariantsAndCalculate, 200);
    }
  }
  
  waitForVariantsAndCalculate();

  // Function to find matching variant in current product based on option values
  function findMatchingVariant(category, height, size) {
    if (!category) return null;
    
    // Use appropriate variant array based on category
    const variantsToSearch = (category.toLowerCase() === 'custom') 
      ? (window.customProductVariants || customProductVariants)
      : (window.productVariants || productVariants || window.razorpayDetails?.productVariants);
    
    if (!variantsToSearch || variantsToSearch.length === 0) return null;
    
    // First, try to find exact match
    let matchingVariant = variantsToSearch.find(variant => {
      const matchCategory = variant.option1 === category;
      const matchHeight = !height || variant.option2 === height;
      const matchSize = !size || variant.option3 === size;
      
      return matchCategory && matchHeight && matchSize;
    });
    
    // If no exact match found and we have a size, try to find the nearest size
    if (!matchingVariant && size) {
      matchingVariant = findNearestSizeVariant(category, height, size, variantsToSearch);
    }
    
    return matchingVariant;
  }

  // Function to find variant with nearest available size
  function findNearestSizeVariant(category, height, targetSize, variantsToSearch) {
    // Parse target size dimensions
    const targetDimensions = parseSizeDimensions(targetSize);
    if (!targetDimensions) return null;
    
    // Filter variants by category and height
    const filteredVariants = variantsToSearch.filter(variant => {
      const matchCategory = variant.option1 === category;
      const matchHeight = !height || variant.option2 === height;
      return matchCategory && matchHeight;
    });
    
    if (filteredVariants.length === 0) return null;
    
    let nearestVariant = null;
    let minDistance = Infinity;
    
    filteredVariants.forEach(variant => {
      const variantDimensions = parseSizeDimensions(variant.option3);
      if (!variantDimensions) return;
      
      // Calculate distance (difference in dimensions)
      const distance = Math.sqrt(
        Math.pow(targetDimensions.length - variantDimensions.length, 2) +
        Math.pow(targetDimensions.breadth - variantDimensions.breadth, 2)
      );
      
      if (distance < minDistance) {
        minDistance = distance;
        nearestVariant = variant;
      }
    });
    
    return nearestVariant;
  }

  // Function to parse size string into dimensions
  function parseSizeDimensions(sizeString) {
    if (!sizeString) return null;
    
    // Handle formats like "72 in x 36 in", "72\" x 36\"", etc.
    const match = sizeString.match(/(\d+(?:\.\d+)?)\s*"?\s*x\s*(\d+(?:\.\d+)?)\s*"?/i);
    if (!match) return null;
    
    return {
      length: parseFloat(match[1]),
      breadth: parseFloat(match[2])
    };
  }

  // Function to apply preserved selections from URL parameters
  function applyPreservedSelections() {
    // Apply preserved unit first so labels and parsing use the right unit
    // For custom category, only inches is allowed
    const allowedUnits = (preservedCategory && preservedCategory.toLowerCase() === 'custom')
      ? ['in']
      : ['in', 'ft', 'cm'];
    if (preservedUnit && allowedUnits.includes(preservedUnit)) {
      const unitRadio = document.querySelector(`input[name="size-option-selector"][value="${preservedUnit}"]`);
      if (unitRadio && !unitRadio.checked) {
        unitRadio.checked = true;
        unitRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // Always apply preserved category/height to the UI even if we cannot resolve a variant yet
    if (preservedCategory) {
      const categoryInput = variantWrapper.querySelector(`input[name="${categoryGroupName}"][value="${preservedCategory}"]`);
      if (categoryInput && !categoryInput.checked) {
        categoryInput.checked = true;
        categoryInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    if (preservedHeight) {
      const heightInput = variantWrapper.querySelector(`input[name="${heightGroupName}"][value="${preservedHeight}"]`);
      if (heightInput && !heightInput.checked) {
        heightInput.checked = true;
        heightInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // Only apply preserved size for non-custom categories
    if (preservedSize && (!preservedCategory || preservedCategory.toLowerCase() !== 'custom')) {
      const sizeInputsEls = variantWrapper.querySelectorAll(`input[name="${sizeGroupName}"]`);
      for (const input of sizeInputsEls) {
        if (input.value === preservedSize) {
          if (!input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
          break;
        }
      }
    }

    // Populate custom inputs if coming from a Custom flow
    if (preservedCategory && preservedCategory.toLowerCase() === 'custom') {
      setTimeout(() => {
        let changed = false;
        if (lengthInputElem && preservedCustomLength) {
          lengthInputElem.value = preservedCustomLength;
          lengthInputElem.dispatchEvent(new Event('input', { bubbles: true }));
          changed = true;
        }
        if (breadthInputElem && preservedCustomBreadth) {
          breadthInputElem.value = preservedCustomBreadth;
          breadthInputElem.dispatchEvent(new Event('input', { bubbles: true }));
          changed = true;
        }
        if (changed) {
          validateCombinedRange(lengthInputElem, breadthInputElem, minLength, maxLength, minBreadth, maxBreadth);
          updateURLWithNearestVariant();
        }
      }, 250);
    }

    // Try to resolve a matching variant after applying selections (safe if none found)
    const matchingVariant = findMatchingVariant(preservedCategory, preservedHeight, preservedSize);
    if (matchingVariant) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', matchingVariant.id);
      window.history.replaceState({}, '', url.toString());
      updatePriceUI(matchingVariant);
    }

    // Ensure labels are in sync
    setTimeout(() => {
      updateSizeOptions();
      updateSizeLabels();
    }, 200);
  }

  // Apply preserved selections after a short delay to ensure DOM is ready
  setTimeout(() => {
    console.log('Applying preserved selections:', {
      category: preservedCategory,
      height: preservedHeight,
      size: preservedSize,
      customLength: preservedCustomLength,
      customBreadth: preservedCustomBreadth
    });
    
    applyPreservedSelections();
    
    // Clean up URL parameters after applying selections
    if (preservedCategory || preservedHeight || preservedSize || preservedCustomLength || preservedCustomBreadth) {
      const cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete('category');
      cleanUrl.searchParams.delete('height');
      cleanUrl.searchParams.delete('size');
      cleanUrl.searchParams.delete('custom_length');
      cleanUrl.searchParams.delete('custom_breadth');
      cleanUrl.searchParams.delete('unit');
      cleanUrl.searchParams.delete('size_unit');
      window.history.replaceState({}, '', cleanUrl.toString());
    }
  }, 500); // Increased delay to ensure all initialization is complete

  minusBtn?.addEventListener('click', () => {
    qtyInput.value = Math.max(1, parseInt(qtyInput.value) - 1);
    qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
  });

  plusBtn?.addEventListener('click', () => {
    qtyInput.value = parseInt(qtyInput.value) + 1;
    qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
  });


  function checkStanderdCustomSize(){

    setTimeout(() => {
      var exactMatched;
      const selected_length = toInchesFromCurrentUnit(lengthInputElem.value);
      const selected_breadth = toInchesFromCurrentUnit(breadthInputElem.value);
      const selectedCustomRadio = document.querySelector('#custom_variant:checked');

      if (selected_length && selected_breadth && selectedCustomRadio) {

        const formattedSize = `${selected_length}\" x ${selected_breadth}\"`;
        const selectedHeight = getSelectedHeight();

        if (selectedHeight) {
          exactMatched = (window.productVariants || productVariants || window.razorpayDetails?.productVariants || []).find(variant =>
            variant.option2 === selectedHeight &&
            variant.option3 === formattedSize
          );
        }else{
          exactMatched = (window.productVariants || productVariants || window.razorpayDetails?.productVariants || []).find(variant =>
            variant.option2 === formattedSize
          );
        }

        if (exactMatched) {
          updatePriceUI(exactMatched);
        }
      }
    },300)

  }

  lengthInputElem.addEventListener('input', checkStanderdCustomSize);
    lengthInputElem.addEventListener('blur', checkStanderdCustomSize);
    breadthInputElem.addEventListener('input', checkStanderdCustomSize);
    breadthInputElem.addEventListener('blur', checkStanderdCustomSize);

    sizeInputs.forEach(radio => {
      radio.addEventListener('change', checkStanderdCustomSize);
    });
    heightInputs.forEach(height => {
      height.addEventListener('change', checkStanderdCustomSize);
    });
      qtyInput.addEventListener('change', checkStanderdCustomSize);


  addToCartBtns?.forEach(btn => {
    btn.addEventListener('click', async () => {
      const qty = parseInt(qtyInput?.value || '1');

      const selectedCategory = getSelectedCategory();
      const selectedSize = getSelectedSize();
      const selectedHeight = getSelectedHeight();

      let matchedVariant;
      let selected_length;
      let selected_breadth;

      let customButRecentCorrectVariant = false;

      if (String(selectedCategory).toLowerCase() === 'custom') {
        selected_length = toInchesFromCurrentUnit(lengthInputElem.value);
        selected_breadth = toInchesFromCurrentUnit(breadthInputElem.value);
        
        matchedVariant = findNearestVariant(selected_length, selected_breadth, selectedHeight, (window.customProductVariants || customProductVariants || []));

        var exactMatched;
        const selectedCustomRadio = document.querySelector('#custom_variant:checked');

        if (selected_length && selected_breadth && selectedCustomRadio) {

          const formattedSize = `${selected_length}\" x ${selected_breadth}\"`;

          if (selectedHeight) {
            exactMatched = (window.productVariants || productVariants || window.razorpayDetails?.productVariants || []).find(variant =>
              variant.option2 === selectedHeight &&
              variant.option3 === formattedSize
            );
          }else{
            exactMatched = (window.productVariants || productVariants || window.razorpayDetails?.productVariants || []).find(variant =>
              variant.option2 === formattedSize
            );
          }

          if (exactMatched) {
            matchedVariant = exactMatched;
            console.log("exactMatched ==> ", exactMatched);
          }
        }
        
        if (!matchedVariant) {
          
          if(document.querySelector('.select-custom-size') != null){
            customButRecentCorrectVariant = true;
            console.log('Falling back to recently selected variant with dimensions');
          } else {
            alert("No suitable variant found for your custom dimensions");
            return;
          }
        }
      } else {
        matchedVariant = (window.productVariants || productVariants || window.razorpayDetails?.productVariants || []).find(v =>
          v.option1 === selectedCategory &&
          v.option2 === selectedHeight &&
          v.option3 === selectedSize
        );
      }

      let variantId = null;
      if(matchedVariant) {
        variantId = matchedVariant.id;
      }

      if(customButRecentCorrectVariant || document.querySelector('.select-custom-size') != null){
        const dimesnions = document.getElementById('dev_selected_variant_option3').textContent;
        selected_length = toInchesFromCurrentUnit(dimesnions.split('x')[0]);
        selected_breadth = toInchesFromCurrentUnit(dimesnions.split('x')[1]);
        const urlCurrent = new URL(window.location.href);
        variantId = urlCurrent.searchParams.get('variant') || variantId;
        console.log('urlParams:', urlCurrent.searchParams.get('variant'));
      } else if (!matchedVariant) {
          return;
      }

      console.log("Selected variant to add to cart:", variantId, matchedVariant);
      try {
        const cartPayload = {
          id: variantId,
          quantity: qty
        };
        
        if (String(selectedCategory).toLowerCase() === 'custom') {
          cartPayload.properties = {
            "Length": `${selected_length}"`,
            "Breadth": `${selected_breadth}"`,
            "Height": selectedHeight || matchedVariant.option2
          };
        } else {
          const sizeParts = selectedSize.match(/(\d+(?:\.\d+)?)\s*"\s*x\s*(\d+(?:\.\d+)?)\s*"/);
          if (sizeParts) {
            cartPayload.properties = {
              "Length": `${sizeParts[1]}"`,
              "Breadth": `${sizeParts[2]}"`,
              "Height": selectedHeight
            };
          }
        }

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(cartPayload)
        });

        if (!response.ok) throw new Error("Add to cart failed");

        console.log("Add to cart response:", response);

        const responseData = await response.json();
        window.dispatchEvent(new CustomEvent('global:addToCart', { detail: { ...responseData, requestedQty: qty ? qty : 1 } }));

        const ajaxCartEl = document.querySelector('#shopify-section-ajaxcart .ajaxcart-content');
        if (ajaxCartEl) {
          ajaxCartEl.setAttribute('open', '');
          refreshBundleCart();
        }
      } catch (err) {
        console.error(err);
      }
      document.getElementById('pv-pdp-variant-full-wrapper').style.display = 'none';
      document.body.style.overflow = 'unset';
      document.body.classList.remove('pv-variant-popup-open');
      if(btn.closest('.sticky-stc-mobile-wrap')){
       gaEvent('TSC_atc', ['PDP Bottom Floater', '', '', '', '', ''], false);
      }
    });
  });

  const allSizeLabels = Array.from(sizeInputs).map(input =>
    variantWrapper.querySelector(`label[for="${input.id}"]`)
  );

  function convertUnit(value, unit) {
    if (!value.includes("x")) return value;

    const parts = value.split("x").map(part => {
      const num = parseFloat(part);
      if (isNaN(num)) return part.trim();

      switch (unit) {
        case 'cm': return (num * 2.54).toFixed(1) + ' cm';
        case 'ft': return (num / 12).toFixed(1) + ' ft';
        case 'in':
        default: return num + ' in';
      }
    });

    return parts.join(" x ");
  }

  function getSelectedUnit() {
    const selected = document.querySelector('input[name="size-option-selector"]:checked');
    return selected ? selected.value : 'in';
  }

  // Convert a numeric value from the currently selected UI unit to inches
  function toInchesFromCurrentUnit(rawValue) {
    const num = parseFloat(String(rawValue).trim());
    if (isNaN(num)) return NaN;
    const unit = getSelectedUnit();
    switch (unit) {
      case 'ft': return +(num * 12).toFixed(1);
      case 'cm': return +(num / 2.54).toFixed(1);
      case 'in':
      default: return num;
    }
  }

  // Convert a numeric value from inches to the currently selected UI unit
  function fromInchesToCurrentUnit(inchesValue) {
    if (isNaN(inchesValue)) return NaN;
    const unit = getSelectedUnit();
    switch (unit) {
      case 'ft': return +(inchesValue / 12).toFixed(1);
      case 'cm': return +(inchesValue * 2.54).toFixed(1);
      case 'in':
      default: return inchesValue;
    }
  }

  // Get the unit label/symbol for the currently selected unit
  function getCurrentUnitLabel() {
    const unit = getSelectedUnit();
    switch (unit) {
      case 'ft': return 'ft';
      case 'cm': return 'cm';
      case 'in':
      default: return '"';
    }
  }

  function updateSizeLabels() {
    const selectedUnit = getSelectedUnit();

    sizeInputs.forEach((input, index) => {
      const label = allSizeLabels[index];
      const cleanedValue = input.value.replace(/"/g, '').trim();
      label.textContent = convertUnit(cleanedValue, selectedUnit);
    });
    
    // Update the custom dimensions title based on selected unit
    updateCustomDimensionsTitle();
  }

  function updateCustomDimensionsTitle() {
    const titleElem = document.getElementById('custom-dimensions-title');
    if (titleElem) {
      const selectedUnit = getSelectedUnit();
      let unitLabel = 'inches';
      switch (selectedUnit) {
        case 'ft': unitLabel = 'feet'; break;
        case 'cm': unitLabel = 'centimeters'; break;
        case 'in':
        default: unitLabel = 'inches'; break;
      }
      titleElem.textContent = `Dimensions (in ${unitLabel})`;
    }
  }

  // Mirrors the two error conditions in validateCombinedRange() (out-of-range, and -- for
  // inches -- not a whole or .5 increment) so a callout can be hidden independently of the
  // other field the moment its own value is invalid.
  function isDimensionValueValid(rawValue, min, max) {
    const trimmed = (rawValue || '').trim();
    if (!trimmed) return false;

    const inches = toInchesFromCurrentUnit(trimmed);
    if (isNaN(inches) || inches < min || inches > max) return false;

    const selectedSizeUnit = document.querySelector('input[name="size-option-selector"]:checked');
    if (selectedSizeUnit && selectedSizeUnit.value === 'in') {
      const validRegex = /^\d{1,4}(?:\.(?:0|5))?$/;
      if (!validRegex.test(trimmed)) return false;
    }

    return true;
  }

  // Keep the length/breadth/height callouts on the dimension diagram in sync with the
  // currently entered custom Length/Breadth and the currently selected Height. Each callout is
  // hidden until it has a real, valid value to show.
  function updateDimensionDiagramCallouts() {
    const lengthCallout = document.getElementById('dev_pv-dimension-callout-length');
    const lengthValueElem = document.getElementById('dev_pv-dimension-callout-length-value');
    const breadthCallout = document.getElementById('dev_pv-dimension-callout-breadth');
    const breadthValueElem = document.getElementById('dev_pv-dimension-callout-breadth-value');
    const heightCallout = document.getElementById('dev_pv-dimension-callout-height');
    const heightValueElem = document.getElementById('dev_pv-dimension-callout-height-value');

    if (lengthCallout && lengthValueElem) {
      const lengthVal = (lengthInputElem.value || '').trim();
      lengthValueElem.textContent = lengthVal;
      lengthCallout.style.display = isDimensionValueValid(lengthVal, minLength, maxLength) ? '' : 'none';
    }

    if (breadthCallout && breadthValueElem) {
      const breadthVal = (breadthInputElem.value || '').trim();
      breadthValueElem.textContent = breadthVal;
      breadthCallout.style.display = isDimensionValueValid(breadthVal, minBreadth, maxBreadth) ? '' : 'none';
    }

    if (heightCallout && heightValueElem) {
      const selectedHeight = getSelectedHeight();
      const heightMatch = selectedHeight ? String(selectedHeight).match(/(\d+(?:\.\d+)?)/) : null;
      heightValueElem.textContent = heightMatch ? heightMatch[1] : '';
      heightCallout.style.display = heightMatch ? '' : 'none';
    }
  }

  function updatePriceUI(variant) {
    const priceEls = document.querySelectorAll('.dev_update-price-onvariantchange');
    const compareEls = document.querySelectorAll('.dev_update-compareatprice-onvariantchange');
    const discountEls = document.querySelectorAll('.dev_update-discount-onvariantchange');

    const price = (variant.price / 100).toLocaleString('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
    });

    const compareAt = variant.compare_at_price ? (variant.compare_at_price / 100) : null;

    priceEls.forEach(el => {
      el.textContent = price;
    });

    compareEls.forEach(el => {
      if (compareAt && compareAt > variant.price / 100) {
        el.querySelector('span').textContent = `₹${compareAt.toLocaleString('en-IN')}`;
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
    });

    discountEls.forEach(el => {
      if (compareAt && compareAt > variant.price / 100) {
        const discount = Math.round(((compareAt - variant.price / 100) / compareAt) * 100);
        el.textContent = `${discount}% OFF`;
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
    });

    if (document.querySelector('.pdp-dynamic-popup')) {
      const popupVariantEls  = document.querySelector('.pdp-dynamic-popup .pdp-dc-header-p-varient');
      const popupCompareEls  = document.querySelector('.pdp-dynamic-popup .pdp-dc-price-main .pdp-dc-price-value');
      const popupPriceEls    = document.querySelector('.pdp-dynamic-popup .pdp-dc-price-discounted .pdp-dc-price-value');
      const popupDiscountEls = document.querySelector('.pdp-dynamic-popup .pdp-dc-price-badge span');

      if (popupVariantEls)  popupVariantEls.textContent  = variant.title;
      if (popupPriceEls)    popupPriceEls.textContent    = price;
      if (popupCompareEls)  popupCompareEls.textContent  = (compareAt && compareAt > variant.price / 100) 
        ? `₹${compareAt.toLocaleString('en-IN')}` 
        : '';
      if (popupDiscountEls) popupDiscountEls.textContent = (compareAt && compareAt > variant.price / 100) 
        ? `${Math.round(((compareAt - variant.price / 100) / compareAt) * 100)}% OFF` 
        : '';
    }

  }

  function updateURLWithNearestVariant() {
    const selectedCategory = getSelectedCategory();
    
    if (String(selectedCategory).toLowerCase() === 'custom') {
      const length = toInchesFromCurrentUnit(lengthInputElem.value);
      const breadth = toInchesFromCurrentUnit(breadthInputElem.value);
      
      if (!isNaN(length) && !isNaN(breadth) && 
          length >= minLength && length <= maxLength && 
          breadth >= minBreadth && breadth <= maxBreadth) {
        
        const nearestVariant = findNearestVariant(length, breadth, getSelectedHeight(), (window.customProductVariants || customProductVariants || []));
        
        if (nearestVariant) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', nearestVariant.id);
          window.history.replaceState({}, '', url);
          updatePriceUI(nearestVariant);
          document.getElementById('dev_selected_variant_option3').textContent = `${length}" x ${breadth}"`;
          document.getElementById('dev_selected_variant_option1').textContent = 'Custom';
          console.log("Nearest variant found and URL updated:",length,breadth, nearestVariant);
        }
      }
    }
  }

  function findNearestVariant(customLength, customBreadth, customHeight, variantsArray) {
    const availableVariants = (variantsArray || []).filter(v => v.available);
    console.log(availableVariants,'availableVariants');
    // Filter variants that are equal to or larger than custom dimensions
    const eligibleVariants = availableVariants.filter(variant => {
      const sizeOption = variant.option3;
      const heightOption = variant.option2;
      
      if (!sizeOption || !heightOption || heightOption !== customHeight) return false;
      
      const sizeParts = sizeOption.match(/(\d+(?:\.\d+)?)\s*"\s*x\s*(\d+(?:\.\d+)?)\s*"/);
      if (!sizeParts) return false;
      
      const variantLength = parseFloat(sizeParts[1]);
      const variantBreadth = parseFloat(sizeParts[2]);
      
      // Only consider variants that are >= custom dimensions in both length and breadth
      return variantLength >= customLength && variantBreadth >= customBreadth;
    });
    
    if (eligibleVariants.length === 0) {
      if(!Number.isNaN(customLength) && !Number.isNaN(customBreadth)){
        variantWrapper.classList.add('pv-variant-atc-disabled');
        addToCartBtns.forEach(button => {
          button.innerText = 'Sold out';
        });
        dimensionErrorWrp.style.display = 'flex';
        errorMessgageElem.textContent = "Sorry! Looks like we don't have the size you're looking for.";
      }
      //console.log('not found','customLength:',customLength,'customBreadth:',customBreadth);
      console.log("No variants found that are larger than or equal to custom dimensions");
      return null;
    }
    
    let nearestVariant = null;
    let minDistance = Infinity;
    let minBreadthDiff = Infinity;
    
    eligibleVariants.forEach(variant => {
      const sizeOption = variant.option3;
      const sizeParts = sizeOption.match(/(\d+(?:\.\d+)?)\s*"\s*x\s*(\d+(?:\.\d+)?)\s*"/);
      
      const variantLength = parseFloat(sizeParts[1]);
      const variantBreadth = parseFloat(sizeParts[2]);
      
      // Calculate distance (preference for smaller variants among eligible ones)
      const distance = Math.sqrt(
        Math.pow(customBreadth - variantBreadth, 2) +
        Math.pow(customLength - variantLength, 2)
      );
      
      const breadthDiff = Math.abs(customBreadth - variantBreadth);
      
      if (distance < minDistance) {
        minDistance = distance;
        minBreadthDiff = breadthDiff;
        nearestVariant = variant;
      } 
      else if (Math.abs(distance - minDistance) < 0.001 && breadthDiff < minBreadthDiff) {
        minBreadthDiff = breadthDiff;
        nearestVariant = variant;
      }
    });
    
    return nearestVariant;
  }

  document.querySelectorAll('input[name="size-option-selector"]').forEach(input => {
    input.addEventListener("change", updateSizeLabels);
  });

  function getSelectedCategory() {
    const checked = variantWrapper.querySelector(`input[name="${categoryGroupName}"]:checked`);
    return checked ? checked.value : null;
  }

  function getSelectedHeight() {
    const checked = variantWrapper.querySelector(`input[name="${heightGroupName}"]:checked`);
    return checked ? checked.value : null;
  }

  function getSelectedSize() {
    const checked = variantWrapper.querySelector(`input[name="${sizeGroupName}"]:checked`);
    return checked ? checked.value : null;
  }

function getValidSizesForCategory(selectedCategory, selectedHeight = null) {
  const variantsToUse = (String(selectedCategory).toLowerCase() === 'custom') 
    ? (window.customProductVariants || customProductVariants || [])
    : (window.productVariants || productVariants || window.razorpayDetails?.productVariants || []);

  let filteredVariants;

  if (String(selectedCategory).toLowerCase() === 'custom') {
    filteredVariants = (variantsToUse || []).filter(v => {
      return !selectedHeight || v.option2 === selectedHeight;
    });
  } else {
    filteredVariants = (variantsToUse || []).filter(v => {
      const matchCategory = v.option1 === selectedCategory;
      const matchHeight = !selectedHeight || v.option2 === selectedHeight; 
      return matchCategory && matchHeight;
    });
  }

  return filteredVariants.map(v => v.option3 || v.option2);
}

  function findSelectedVariant() {
    const selectedCategory = getSelectedCategory();
    const selectedSize = getSelectedSize();
    const selectedHeight = getSelectedHeight();
    
    console.log("selectedCategory ==> ", selectedCategory);
    console.log("selectedSize ==> ", selectedSize);
    console.log("selectedHeight ==> ", selectedHeight);

    let selected_length;
    let selected_breadth;

    // Use custom product variants when custom is selected, otherwise use normal product variants with category
    if (String(selectedCategory).toLowerCase() === 'custom') {
      // For custom category, use custom product variants and ignore selectedCategory
      // const matchedaa = (customProductVariants || []).find(v =>
      //   v.option2 === selectedHeight &&
      //   v.option3 === selectedSize
      // );

      selected_length = parseFloat(lengthInputElem.value.trim());
      selected_breadth = parseFloat(breadthInputElem.value.trim());

      const matched = findNearestVariant(selected_length, selected_breadth, selectedHeight, (window.customProductVariants || customProductVariants || []));
      console.log("matched aaas==> ", matched);



      if (matched) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', matched.id);
        window.history.replaceState({}, '', url);
        updatePriceUI(matched);
        
        variantWrapper.classList.remove('pv-variant-atc-disabled');
        addToCartBtns.forEach(button => {
          button.innerText = 'Add to Cart';
        });
        dimensionErrorWrp.style.display = 'none';
        errorMessgageElem.textContent = "";
        
      } else {
        console.log("No matching custom variant found");
      }
    } else {
      // For normal products, use selectedCategory in matching
      const matched = (window.productVariants || productVariants || window.razorpayDetails?.productVariants || []).find(v =>
        v.option1 === selectedCategory &&
        v.option2 === selectedHeight &&
        v.option3 === selectedSize
      );

      if (matched) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', matched.id);
        window.history.replaceState({}, '', url);
        updatePriceUI(matched);
      } else {
        console.log("No matching variant found");
      }

      const matched_availalevari = (window.productVariants || productVariants || window.razorpayDetails?.productVariants || []).find(v =>
        v.option1 === selectedCategory &&
        v.option2 === selectedHeight &&
        v.option3 === selectedSize &&
        v.available // ✅ ensure variant is in stock
      );

      if (matched_availalevari) {
        document.querySelector(".pv-variant-atc-wrapper .mattress-pdp-atc-btn").style.display = "block";
        document.querySelector("#notify-btn").style.display = "none";
        document.querySelector(".out_of_stock").style.display = "none";
        document.querySelector(".out_of_stock_card").style.display = "none";
        document.querySelector(".mattress-pdp-quantity-wrap .notify-btn").style.display = "none";
        document.querySelector(".mattress-pdp-quantity-wrap .mattress-pdp-atc-btn").style.display = "block";
        // setTimeout(function () {
        // //  document.querySelector(".custom-pincode-container .estimate-widget").style.display = "block";
        // }, 2000);
      }else{
        document.querySelector(".pv-variant-atc-wrapper .mattress-pdp-atc-btn").style.display = "none";
        document.querySelector("#notify-btn").style.display = "flex";
        document.querySelector(".out_of_stock").style.display = "block";
        document.querySelector(".out_of_stock_card").style.display = "block";
        document.querySelector(".mattress-pdp-quantity-wrap .notify-btn").style.display = "flex";
        document.querySelector(".mattress-pdp-quantity-wrap .mattress-pdp-atc-btn").style.display = "none";
        // setTimeout(function () {
        //  // document.querySelector(".custom-pincode-container .estimate-widget").style.display = "none";
        // }, 2000);
      }
    }
  }

  // Function to implement height selection logic
  function selectOptimalHeight() {
    const selectedCategory = getSelectedCategory();
    if (!selectedCategory) return;

    const variantsToUse = (String(selectedCategory).toLowerCase() === 'custom') 
      ? customProductVariants 
      : productVariants;

    if (!variantsToUse || variantsToUse.length === 0) return;

    // Get available heights for the selected category
    const availableHeights = [...new Set(variantsToUse
      .filter(v => v.option1 === selectedCategory)
      .map(v => v.option2)
      .filter(Boolean)
    )].sort((a, b) => {
      // Extract numeric value from height string (e.g., "6 inches" -> 6)
      const aNum = parseFloat(a.replace(/[^\d.]/g, ''));
      const bNum = parseFloat(b.replace(/[^\d.]/g, ''));
      return aNum - bNum;
    });

    if (availableHeights.length === 0) return;

    // Find the optimal height based on the logic:
    // 1. If height > 5 is available, select the first one
    // 2. If height > 6 is available, select the first one  
    // 3. Otherwise, fallback to the lowest available height
    let selectedHeight = null;
    
    // First try to find height > 5
    for (const height of availableHeights) {
      const heightNum = parseFloat(height.replace(/[^\d.]/g, ''));
      if (heightNum > 5) {
        selectedHeight = height;
        break;
      }
    }
    
    // If no height > 5 found, try height > 6
    if (!selectedHeight) {
      for (const height of availableHeights) {
        const heightNum = parseFloat(height.replace(/[^\d.]/g, ''));
        if (heightNum > 6) {
          selectedHeight = height;
          break;
        }
      }
    }
    
    // If still no height found, fallback to the lowest available height
    if (!selectedHeight) {
      selectedHeight = availableHeights[0]; // Fallback to lowest
    }

    // Select the height in the UI
    const heightInput = variantWrapper.querySelector(`input[name="${heightGroupName}"][value="${selectedHeight}"]`);
    if (heightInput && !heightInput.checked) {
      heightInput.checked = true;
      heightInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // Function to select optimal size (keep the previous size if still valid,
  // else the nearest available size to it, else 78x72, else first available)
  function selectOptimalSize(previousSize) {
    const selectedCategory = getSelectedCategory();
    const selectedHeight = getSelectedHeight();
    if (!selectedCategory || !selectedHeight) return;

    // If the previously selected size is still valid for this category/height
    // (updateSizeOptions already re-checked it), keep it instead of jumping
    // back to the 78x72 default.
    const alreadyValidSize = variantWrapper.querySelector(`input[name="${sizeGroupName}"]:checked:not(:disabled)`);
    if (alreadyValidSize) return;

    const variantsToUse = (String(selectedCategory).toLowerCase() === 'custom')
      ? customProductVariants
      : productVariants;

    if (!variantsToUse || variantsToUse.length === 0) return;

    // Get available sizes for the selected category and height
    const availableSizes = variantsToUse
      .filter(v => v.option1 === selectedCategory && v.option2 === selectedHeight && v.available)
      .map(v => v.option3)
      .filter(Boolean);

    if (availableSizes.length === 0) return;

    // The exact previous size isn't available here — fall back to whichever
    // available size is dimensionally closest to it, rather than jumping
    // straight to the 78x72 default.
    if (previousSize) {
      const nearest = findNearestSizeVariant(selectedCategory, selectedHeight, previousSize, variantsToUse);
      if (nearest && nearest.option3) {
        const escapedNearest = nearest.option3.replace(/"/g, '\\"');
        const nearestInput = variantWrapper.querySelector(`input[name="${sizeGroupName}"][value="${escapedNearest}"]`);
        if (nearestInput && !nearestInput.checked) {
          nearestInput.checked = true;
          nearestInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }
    }

    // Try to find 78x72 size first
    const possible78x72Sizes = [
      '78" x 72"',
      '78" x 72',
      '78 x 72"',
      '78 x 72',
      '78"x72"',
      '78x72"',
      '78"x72',
      '78x72'
    ];

    let selectedSize = null;
    
    // First try to find 78x72 size
    for (const size of possible78x72Sizes) {
      if (availableSizes.includes(size)) {
        selectedSize = size;
        break;
      }
    }

    // If 78x72 not found, fallback to first available size
    if (!selectedSize) {
      selectedSize = availableSizes[0];
    }

    // Select the size in the UI
    const escapedSize = selectedSize.replace(/"/g, '\\"');
    const sizeInput = variantWrapper.querySelector(`input[name="${sizeGroupName}"][value="${escapedSize}"]`);
    if (sizeInput && !sizeInput.checked) {
      sizeInput.checked = true;
      sizeInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // Function to select variant from URL parameter (for marketing campaigns)
  function selectVariantFromURL(variantId) {
    const productVariantsToUse = window.productVariants || productVariants || window.razorpayDetails?.productVariants || [];
    if (!productVariantsToUse || productVariantsToUse.length === 0) {
      return;
    }

    // Find the variant by ID
    const targetVariant = productVariantsToUse.find(variant => 
      String(variant.id) === String(variantId)
    );

    if (!targetVariant) {
      console.log("Variant not found in URL parameter, using default selection");
      autoSelectDefaultMattress();
      return;
    }

    console.log("Selecting variant from URL:", targetVariant);

    // Select the category if it exists
    if (targetVariant.option1) {
      const categoryInput = variantWrapper.querySelector(`input[name="${categoryGroupName}"][value="${targetVariant.option1}"]`);
      if (categoryInput && !categoryInput.checked) {
        categoryInput.checked = true;
        categoryInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // Select the height if it exists
    if (targetVariant.option2) {
      const heightInput = variantWrapper.querySelector(`input[name="${heightGroupName}"][value="${targetVariant.option2}"]`);
      if (heightInput && !heightInput.checked) {
        heightInput.checked = true;
        heightInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // Select the size if it exists - escape quotes in the value
    if (targetVariant.option3) {
      const escapedSize = targetVariant.option3.replace(/"/g, '\\"');
      const sizeInput = variantWrapper.querySelector(`input[name="${sizeGroupName}"][value="${escapedSize}"]`);
      if (sizeInput && !sizeInput.checked) {
        sizeInput.checked = true;
        sizeInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // Update price UI
    updatePriceUI(targetVariant);

    // The category/height/size inputs above only dispatch 'change' when their checked
    // state actually flips. If the URL's variant is already the server-rendered default,
    // none of them flip, so the ATC button label never updates. Sync it explicitly here.
    validateAdToCart();
  }

  // Function to auto-select 78x72x6 mattress variant on PDP load
  function autoSelectDefaultMattress() {
    const productVariantsToUse = window.productVariants || productVariants || window.razorpayDetails?.productVariants || [];
    if (!productVariantsToUse || productVariantsToUse.length === 0) {
      return;
    }

    // Try to find 78x72x6 variant first
    let targetVariant = productVariants.find(variant => 
      variant.option2 === '6 inches' && 
      variant.option3 === '78" x 72"' &&
      variant.available
    );

    // If not found, try 78x72x8
    if (!targetVariant) {
      targetVariant = productVariants.find(variant => 
        variant.option2 === '8 inches' && 
        variant.option3 === '78" x 72"' &&
        variant.available
      );
    }

    // If still not found, try any 78x72 variant
    if (!targetVariant) {
      targetVariant = productVariants.find(variant => 
        variant.option3 && variant.option3.includes('78') && variant.option3.includes('72') &&
        variant.available
      );
    }

    // If still not found, try to find any variant with 78x72 size (different formats)
    if (!targetVariant) {
      const possible78x72Sizes = [
        '78" x 72"',
        '78" x 72',
        '78 x 72"',
        '78 x 72',
        '78"x72"',
        '78x72"',
        '78"x72',
        '78x72'
      ];
      
      for (const size of possible78x72Sizes) {
        targetVariant = productVariants.find(variant => 
          variant.option3 === size && variant.available
        );
        if (targetVariant) break;
      }
    }

    // If still not found, just get the first available variant
    if (!targetVariant) {
      targetVariant = productVariants.find(variant => variant.available);
    }

    if (targetVariant) {
      // Force select the category
      const categoryInput = variantWrapper.querySelector(`input[name="${categoryGroupName}"][value="${targetVariant.option1}"]`);
      if (categoryInput) {
        categoryInput.checked = true;
        categoryInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Force select the height
      const heightInput = variantWrapper.querySelector(`input[name="${heightGroupName}"][value="${targetVariant.option2}"]`);
      if (heightInput) {
        heightInput.checked = true;
        heightInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Force select the size - escape quotes in the value
      const escapedSize = targetVariant.option3.replace(/"/g, '\\"');
      const sizeInput = variantWrapper.querySelector(`input[name="${sizeGroupName}"][value="${escapedSize}"]`);
      if (sizeInput) {
        sizeInput.checked = true;
        sizeInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Update URL and price
      const url = new URL(window.location.href);
      url.searchParams.set('variant', targetVariant.id);
      window.history.replaceState({}, '', url.toString());
      updatePriceUI(targetVariant);
    }
  }

  function updateSizeOptions() {
    const selectedCategory = getSelectedCategory();
    const selectedHeight = getSelectedHeight();

    const validSizes = getValidSizesForCategory(selectedCategory, selectedHeight);

    let firstEnabledSizeInput = null;

    sizeInputs.forEach((input, index) => {
      const isValid = validSizes.includes(input.value);
      input.disabled = !isValid;

      const label = allSizeLabels[index];
      if (isValid) {
        label.classList.remove("disabled");

        if (!firstEnabledSizeInput) {
          firstEnabledSizeInput = input;
        }
        if(input.checked == true){
          firstEnabledSizeInput = input;
        }
      } else {
        label.classList.add("disabled");
      }
    });

    if (firstEnabledSizeInput) {
      firstEnabledSizeInput.checked = true;
    }

    findSelectedVariant();
    updateSizeLabels();
  }

  sizeInputs.forEach(input => {
    input.addEventListener("change", () => {
      const selected = input.value;
      document.getElementById('dev_selected_variant_option3').textContent = selected;

      findSelectedVariant();
    });
  });

  heightInputs.forEach(input => {
    input.addEventListener("change", () => {
      const selected = input.value;
      const previousSize = getSelectedSize();
      document.getElementById('dev_selected_variant_option2').textContent = selected;

      updateSizeOptions();
      updateDimensionDiagramCallouts();

      // If custom category is selected, recalculate dimensions and validate again
      const selectedCategory = getSelectedCategory();
      if (String(selectedCategory).toLowerCase() === 'custom') {
        calculateMinMaxDimensions();
        // Re-validate custom inputs after height changes (delayed to ensure min/max are recalculated)
        setTimeout(() => {
          validateCombinedRange(lengthInputElem, breadthInputElem, minLength, maxLength, minBreadth, maxBreadth);
          updateURLWithNearestVariant();
        }, 200);
      }

      // Apply size selection logic after height is selected
      setTimeout(() => {
        selectOptimalSize(previousSize);
      }, 100);

      findSelectedVariant();
    });
  });

  const unitSelector = document.getElementById("size-unit-selector");
  if (unitSelector) {
    unitSelector.addEventListener("change", () => {
      updateSizeLabels();
      // Re-evaluate custom validation and nearest-variant mapping on unit change
      validateCombinedRange(lengthInputElem, breadthInputElem, minLength, maxLength, minBreadth, maxBreadth);
      updateURLWithNearestVariant();
      findSelectedVariant();
    });
  }

  // Check if URL has a variant parameter (from marketing campaigns)
  const urlVariantParam = urlParams.get('variant');
  
  // Only auto-select default mattress if NO variant parameter exists in URL
  if (!urlVariantParam) {
    // Auto-select default mattress variant on page load - try multiple times
    setTimeout(() => {
      autoSelectDefaultMattress();
    }, 1000);

    setTimeout(() => {
      autoSelectDefaultMattress();
    }, 2000);

    setTimeout(() => {
      autoSelectDefaultMattress();
    }, 3000);
  } else {
    // If variant parameter exists, select that specific variant
    setTimeout(() => {
      selectVariantFromURL(urlVariantParam);
    }, 500);
  }

  // Only run initial updates if we don't have preserved selections
  if (!preservedCategory && !preservedHeight && !preservedSize) {
    updateSizeOptions();
    updateSizeLabels();
  }

  const categoryOptionLabels = document.querySelectorAll('.pv-option-section-category .pv_option_btn');
  categoryOptionLabels.forEach(label => {
    label.addEventListener('click', function() {
      const selectedCategory = this.textContent.trim();
      gaEvent('category_selected', [selectedCategory, '', '', '', '', ''], false);
      
      if (String(selectedCategory).toLowerCase() === 'custom') {
        calculateMinMaxDimensions();
      }
    });
  });

  const heightOptionLabels = document.querySelectorAll('.pv-option-section-height .pv_option_btn');
  heightOptionLabels.forEach(label => {
    label.addEventListener('click', function() {
      const selectedCategory = this.textContent.trim();
      gaEvent('height_selected', [selectedCategory, '', '', '', '', ''], false);
    });
  });

  // document.querySelector('.pv-variant-atc-wrapper .mattress-pdp-atc-btn').addEventListener('click', function() {
  //   gaEvent('TSC_atc', ['PDP Bottom Floater', '', '', '', '', ''], false);
  // });
  // document.querySelector('.pv-variant-atc-wrapper').addEventListener('click', function() {
  //   gaEvent('TSC_atc', ['PDP Bottom Floater', '', '', '', '', ''], false);
  // });

  const sizeOptionLabels = document.querySelectorAll('.pv_unit_selector .pv_option_btn');
  sizeOptionLabels.forEach(label => {
    label.addEventListener('click', function() {
      const selectedRadio = document.querySelector('.pv-option-section-size input[type="radio"]:checked');
      console.log('prince-radio', selectedRadio);
      if (selectedRadio) {
        console.log('prince-radio', selectedRadio.nextElementSibling)
        setTimeout(()=>{
          const selectedValue = selectedRadio.nextElementSibling.textContent;

          gaEvent('size_selected', [selectedValue, '', '', '', '', ''], false);
        },20)
      }
    });
  });

  const sizeOptionValueLables = document.querySelectorAll('.pv-option-section-size .pv_option_item');
  sizeOptionValueLables.forEach(label => {
    label.addEventListener('click', function() {
      const selectedValue = this.querySelector('label').textContent.trim();
      gaEvent('size_selected', [selectedValue, '', '', '', '', ''], false);
    });
  });

  function allowOnlyNumbers(event) {
    const key = event.key;
    if (!/[\d.]/.test(key) && key !== 'Backspace' && key !== 'Delete' && key !== 'ArrowLeft' && key !== 'ArrowRight') {
      event.preventDefault();
    }
  }
  
  function validateCombinedRange(lengthElem, breadthElem, minLength, maxLength, minBreadth, maxBreadth) {
    const length = toInchesFromCurrentUnit(lengthElem.value);
    const breadth = toInchesFromCurrentUnit(breadthElem.value);
    const errorElem = document.getElementById('dimension-error');
    const errorWrapElem = document.querySelector('.dimension-error-wrap');
    let messages = [];

    // Get the currently selected unit to display error messages in the correct unit
    const selectedUnit = getSelectedUnit();
    const unitLabel = getCurrentUnitLabel();
    
    // Convert min/max values from inches to the currently selected unit
    const minLengthInUnit = fromInchesToCurrentUnit(minLength);
    const maxLengthInUnit = fromInchesToCurrentUnit(maxLength);
    const minBreadthInUnit = fromInchesToCurrentUnit(minBreadth);
    const maxBreadthInUnit = fromInchesToCurrentUnit(maxBreadth);

    if (lengthElem.value.trim() !== '') {
      if (isNaN(length) || length < minLength || length > maxLength) {
        messages.push(`Length must be between ${minLengthInUnit} ${unitLabel} - ${maxLengthInUnit} ${unitLabel}`);
      }
    }
  
    if (breadthElem.value.trim() !== '') {
      if (isNaN(breadth) || breadth < minBreadth || breadth > maxBreadth) {
        messages.push(`Breadth must be between ${minBreadthInUnit} ${unitLabel} - ${maxBreadthInUnit} ${unitLabel}`);
      }
    }


    // Logic to allow only whole numbers or .5 increments for inches
    const validRegex = /^\d{1,4}(?:\.(?:0|5))?$/;
    const getRangeMessage = (value, fieldName) => {
      const num = parseFloat(value);
      const integerPart = Math.floor(num);
      const decimalPart = Math.round((num - integerPart) * 10) / 10;

      if (decimalPart === 0 || decimalPart === 0.5) {
        return `the ${fieldName} only as ${integerPart} or ${integerPart}.5${unitLabel}`;
      }

      if (decimalPart < 0.5) {
        return `the ${fieldName} only as ${integerPart}${unitLabel} or ${integerPart}.5${unitLabel}`;
      }

      return `the ${fieldName} only as ${integerPart}.5${unitLabel} or ${integerPart + 1}${unitLabel}`;
    };
    let messagesNew = [];
    const selectedSizeUnit = document.querySelector('input[name="size-option-selector"]:checked');
    if (selectedSizeUnit && selectedSizeUnit.value === 'in') {
      if (lengthElem.value.trim() !== '') {
         if (length >= minLength && length <= maxLength) {
            if (!validRegex.test(lengthElem.value.trim())) {
              messagesNew.push(getRangeMessage(lengthElem.value.trim(), 'length'));
            }
         }
      }
      if (breadthElem.value.trim() !== '') {
         if (breadth >= minBreadth && breadth <= maxBreadth) {
            if (!validRegex.test(breadthElem.value.trim())) {
              messagesNew.push(getRangeMessage(breadthElem.value.trim(), 'breadth'));
            }
         }
      }
      if (messagesNew.length > 0) {
         messages.push('Please enter ' + messagesNew.join(' and '));
      }
    }


    if (messages.length > 0) {
      errorElem.textContent = messages.join(' and ');
      errorWrapElem.style.display = 'flex';
    } else {
      errorElem.textContent = '';
      errorWrapElem.style.display = 'none';
    }
    validateAdToCart();
  }
  
  [lengthInputElem, breadthInputElem].forEach(elem => {
    elem.addEventListener('keydown', allowOnlyNumbers);
    elem.addEventListener('keyup', () => {
      validateCombinedRange(lengthInputElem, breadthInputElem, minLength, maxLength, minBreadth, maxBreadth);
      updateURLWithNearestVariant();
    });
    // Covers both keyboard typing and the programmatic value + dispatchEvent('input') used
    // elsewhere (e.g. restoring preserved custom dimensions from the URL).
    elem.addEventListener('input', updateDimensionDiagramCallouts);
  });

  function validateAdToCart() {
    const optionSection = document.querySelector('.pv-option-section-custom-size-wrapper');
    const variantWrapperElem = document.querySelector('.pv-pdp-variant-wrapper');
    const successMessage = document.querySelector('#validation-success');
    const mainContent = document.querySelector('#MainContent');
    const atcButtons = document.querySelectorAll('#dev_pv_pdp_variant_wrapper .mattress-pdp-atc-btn');
    
    if (optionSection.style.display !== 'none' 
      && document.querySelector('.dimension-error-wrap').style.display == 'none' 
      && lengthInputElem.value.trim() !== '' 
      && breadthInputElem.value.trim() !== '') {
      variantWrapperElem.classList.remove('pv-variant-atc-disabled');
      // mainContent.classList.remove('pv-variant-atc-disabled');
      atcButtons.forEach(button => {
        button.innerText = 'Confirm';
        button.classList.remove('select-custom-size');
      });
      successMessage.style.display = 'block';
      //document.getElementById('dev_selected_variant_option3').textContent = `${lengthInputElem.value}" x ${breadthInputElem.value}"`;
    } else {
      if (optionSection.style.display == 'none'){
        variantWrapperElem.classList.remove('pv-variant-atc-disabled');
        // mainContent.classList.remove('pv-variant-atc-disabled');
        atcButtons.forEach(button => {
          button.innerText = 'Confirm';
          button.classList.remove('select-custom-size');
        });
      }else if(optionSection.style.display !== 'none' && document.querySelector('.dimension-error-wrap').style.display == 'none' ){
        variantWrapperElem.classList.add('pv-variant-atc-disabled');
        // mainContent.classList.add('pv-variant-atc-disabled');
        atcButtons.forEach(button => {
          button.innerText = 'Add Custom Size';
          button.classList.add('select-custom-size');
        });
      } else {
        variantWrapperElem.classList.add('pv-variant-atc-disabled');
        // mainContent.classList.add('pv-variant-atc-disabled');
        atcButtons.forEach(button => {
          button.innerText = 'Add Custom Size';
          button.classList.add('select-custom-size');
        });
      }
      successMessage.style.display = 'none';
    }
  }

  let preCustomUnit = null;

  function restrictUnitsToInches() {
    const ftInput = document.getElementById('size-option-ft');
    const cmInput = document.getElementById('size-option-cm');
    const inInput = document.getElementById('size-option-in');
    [ftInput, cmInput].forEach(input => {
      if (!input) return;
      input.style.display = 'none';
      const lbl = document.querySelector(`label[for="${input.id}"]`);
      if (lbl) lbl.style.display = 'none';
    });
    if (inInput && !inInput.checked) {
      inInput.checked = true;
      inInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function restoreAllUnits(unitToRestore) {
    ['size-option-ft', 'size-option-cm', 'size-option-in'].forEach(id => {
      const input = document.getElementById(id);
      if (!input) return;
      input.style.display = '';
      const lbl = document.querySelector(`label[for="${id}"]`);
      if (lbl) lbl.style.display = '';
    });
    if (unitToRestore) {
      const unitRadio = document.querySelector(`input[name="size-option-selector"][value="${unitToRestore}"]`);
      if (unitRadio && !unitRadio.checked) {
        unitRadio.checked = true;
        unitRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  categoryInputs.forEach(input => {
    input.addEventListener("change", () => {
      const selected = input.value;
      const previousSize = getSelectedSize();

      if (String(selected).toLowerCase() === 'custom') {
        preCustomUnit = getSelectedUnit();
        //document.getElementById('dev_selected_variant_option1').textContent = 'Custom';
        calculateMinMaxDimensions();
        document.querySelector('.pv_section.pv_section_size').style.display = 'none';
        document.querySelector('.pv_section.pv_section_height').style.marginBottom = '92px';
        document.querySelector('.pv-option-section-custom-size-wrapper').style.display = 'flex';
        updateCustomDimensionsTitle();
        updateDimensionDiagramCallouts();
        restrictUnitsToInches();

        // Re-validate custom inputs when switching to custom category
        calculateMinMaxDimensions();
        setTimeout(() => {
          validateCombinedRange(lengthInputElem, breadthInputElem, minLength, maxLength, minBreadth, maxBreadth);
        }, 200);
      } else {
        const unitToRestore = preCustomUnit;
        preCustomUnit = null;
        lengthInputElem.value = '';
        breadthInputElem.value = '';
        document.getElementById('dev_selected_variant_option1').textContent = selected;
        document.querySelector('.pv_section.pv_section_size').style.display = 'flex';
        document.querySelector('.pv_section.pv_section_height').style.marginBottom = '0';
        document.querySelector('.pv-option-section-custom-size-wrapper').style.display = 'none';
        updateDimensionDiagramCallouts();
        restoreAllUnits(unitToRestore);

        // Apply height selection logic for non-custom categories
        setTimeout(() => {
          selectOptimalHeight();
          updateSizeOptions();

          // Apply size selection logic after height is selected
          setTimeout(() => {
            selectOptimalSize(previousSize);
            document.getElementById('dev_selected_variant_option3').textContent = getSelectedSize();
            findSelectedVariant();
          }, 100);
        }, 100);
      }

      validateAdToCart();
    });
  });

  // Initial sync in case Custom (with pre-filled dimensions/height) is already the
  // server-rendered default selection on page load.
  updateDimensionDiagramCallouts();

  // Highlight current color tile by applying class on the grid wrapper
  (function highlightColorSwatchGrid() {
    try {
      // Inject CSS once (on the grid container)
      if (!document.getElementById('tsc-grid-color-selected-style')) {
        const style = document.createElement('style');
        style.id = 'tsc-grid-color-selected-style';
        style.textContent = '.pv-option-section-color .pv_option_product_grid.tsc-color-selected{border:1px solid #CF2027;border-radius:8px;opacity:1;box-sizing:border-box;}';
        document.head.appendChild(style);
      }

      const currentPath = window.location.pathname.replace(/\/$/, '');
      const grids = document.querySelectorAll('.pv-option-section-color .pv_option_product_grid');
      grids.forEach(grid => {
        grid.classList.remove('tsc-color-selected');
        const link = grid.querySelector('.pv_option_product_link');
        if (!link) return;
        let linkPath = '';
        try {
          linkPath = new URL(link.getAttribute('href') || link.href, window.location.origin).pathname.replace(/\/$/, '');
        } catch (e) {}
        if (linkPath === currentPath) {
          grid.classList.add('tsc-color-selected');
        }
      });
    } catch (e) {}
  })();

  // Keep color swatches order frozen as: Grey, White
  (function freezeColorOrder() {
    try {
      const container = document.querySelector('.pv-option-section-color');
      if (!container) return;
      const grids = Array.from(container.querySelectorAll('.pv_option_product_grid'));
      if (grids.length < 2) return;

      function colorPriority(grid) {
        const name = grid.querySelector('.pv_option_product_name p')?.textContent?.trim()?.toLowerCase() || '';
        if (name.includes('grey') || name.includes('gray')) return 0;
        if (name.includes('white')) return 1;
        return 99;
      }

      grids.sort((a, b) => colorPriority(a) - colorPriority(b));
      grids.forEach(g => container.appendChild(g));
    } catch (e) {}
  })();

  // Prevent redirect when clicking the already-selected color swatch
  document.addEventListener('click', function(e) {
    const link = e.target.closest('.pv-option-section-color .pv_option_product_link');
    if (!link) return;
    try {
      const currentPath = window.location.pathname.replace(/\/$/, '');
      const destPath = new URL(link.getAttribute('href') || link.href, window.location.origin)
        .pathname.replace(/\/$/, '');
      if (destPath === currentPath) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        return;
      }

      // If navigating to a different color PDP, preserve current selections (except custom)
      const destUrl = new URL(link.getAttribute('href') || link.href, window.location.origin);
      const category = getSelectedCategory();
      const height = getSelectedHeight();
      const size = getSelectedSize();
      const unit = getSelectedUnit();

      if (category) {
        destUrl.searchParams.set('category', category);
        if (height) destUrl.searchParams.set('height', height);
        if (String(category).toLowerCase() !== 'custom' && size) {
          destUrl.searchParams.set('size', size);
        } else if (String(category).toLowerCase() === 'custom') {
          const lenVal = lengthInputElem ? String(lengthInputElem.value).trim() : '';
          const brdVal = breadthInputElem ? String(breadthInputElem.value).trim() : '';
          if (lenVal) destUrl.searchParams.set('custom_length', lenVal);
          if (brdVal) destUrl.searchParams.set('custom_breadth', brdVal);
        }
        if (unit) destUrl.searchParams.set('unit', unit);
      }

      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      window.location.href = destUrl.toString();
    } catch (err) {}
  }, true);

  // Minimal: highlight active color swatch based on current page product
  (function highlightActiveColorSwatch() {
    try {
      // Inject CSS once
      if (!document.getElementById('tsc-color-selected-style')) {
        const style = document.createElement('style');
        style.id = 'tsc-color-selected-style';
        style.textContent = 'label.dev_pdp_open_prod_url.tsc-color-selected{border:1px solid #CF2027;border-radius:8px;opacity:1;box-sizing:border-box;}';
        document.head.appendChild(style);
      }

      const currentPath = window.location.pathname.replace(/\/$/, '');
      const labels = document.querySelectorAll('label.dev_pdp_open_prod_url');
      labels.forEach(l => l.classList.remove('tsc-color-selected'));

      let matched = false;
      labels.forEach(label => {
        const rawUrl = label.getAttribute('data-optionurl');
        if (!rawUrl) return;
        try {
          const labelPath = new URL(rawUrl, window.location.origin).pathname.replace(/\/$/, '');
          if (labelPath === currentPath) {
            label.classList.add('tsc-color-selected');
            matched = true;
          }
        } catch (e) {}
      });

      // Fallback: if template marked an input as checked, mirror highlight to its label
      if (!matched) {
        const checkedInput = document.querySelector('input.color-swatch.dev_pdp_open_prod_url:checked');
        if (checkedInput) {
          const forId = checkedInput.getAttribute('id');
          const byFor = forId ? document.querySelector(`label[for="${forId}"]`) : null;
          if (byFor) byFor.classList.add('tsc-color-selected');
        }
      }
    } catch (e) {}
  })();
});

// The "Learn how to measure" block is only shown at all when Category = Custom is selected, but
// stays collapsed by default within that -- it only expands (and starts the muted video) on a
// manual click of the header, and collapses again on a second click, on popup close, or on
// leaving the Custom category.
(function () {
  var popup = document.getElementById('pv-pdp-variant-full-wrapper');
  var learnWrapper = document.getElementById('dev_pv-variant-learn-how-to');
  var learnTextIcon = document.getElementById('dev_pv-variant-learn-text-icon');
  if (!popup || !learnWrapper) return;

  var video = learnWrapper.querySelector('video');
  var source = video ? video.querySelector('source') : null;

  function isCustomSelected() {
    var checked = document.querySelector('input[name="option-category"]:checked');
    return !!checked && String(checked.value).toLowerCase() === 'custom';
  }

  function collapseAndPause() {
    learnWrapper.classList.remove('pv-video-active');
    if (video) video.pause();
  }

  function syncWrapperVisibility() {
    var showCustomFlow = isCustomSelected();
    learnWrapper.style.display = showCustomFlow ? '' : 'none';
    if (!showCustomFlow) collapseAndPause();
  }

  if (learnTextIcon) {
    learnTextIcon.addEventListener('click', function () {
      if (!video || !source) return;
      gaEvent('Learn_to_measure', ['', '', '', '', '', ''], false);

      var isActive = learnWrapper.classList.toggle('pv-video-active');
      if (isActive) {
        if (!source.getAttribute('src')) {
          source.setAttribute('src', source.getAttribute('data-src'));
          video.load();
        }
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      } else {
        video.pause();
      }
    });
  }

  // Collapse + pause when the popup closes, so reopening it doesn't resume mid-video.
  new MutationObserver(function () {
    if (popup.style.display === 'none') collapseAndPause();
  }).observe(popup, {
    attributes: true,
    attributeFilter: ['style']
  });

  // Re-sync whenever the Category selection changes (manual click or restored from URL).
  document.querySelectorAll('input[name="option-category"]').forEach(function (input) {
    input.addEventListener('change', syncWrapperVisibility);
  });

  syncWrapperVisibility();
})();

document.getElementById('dev_pv-variant-popup-close-btn').addEventListener('click', function () { 
  document.getElementById('pv-pdp-variant-full-wrapper').style.display = 'none';
  document.body.style.overflow = 'unset';
  document.body.classList.remove('pv-variant-popup-open');
});

document.getElementById('pv-pdp-variant-full-wrapper').addEventListener('click', function(event) {
  const childWrapper = document.getElementById('dev_pv_pdp_variant_wrapper');
  
  if (!childWrapper.contains(event.target)) {
    document.getElementById('pv-pdp-variant-full-wrapper').style.display = 'none';
    document.body.style.overflow = 'unset';
    document.body.classList.remove('pv-variant-popup-open');
  }
});

const confirmButton = document.querySelector('#pv-pdp-variant-full-wrapper .mattress-pdp-atc-btn');
if(confirmButton){
    confirmButton.addEventListener("click", function () {
        document.getElementById('pv-pdp-variant-full-wrapper').style.display = 'none';
        document.body.style.overflow = 'unset';
        document.body.classList.remove('pv-variant-popup-open');
        if (window.innerWidth < 991) {
          let optionSelectedLabel = document.querySelector('.mattress-pdp-main-prod .product-size label');
          if (optionSelectedLabel.textContent.includes("Select Size")) {
              optionSelectedLabel.textContent = optionSelectedLabel.textContent.replace("Select Size", "Selected Size");
          }
        }
        var p_type = document.querySelector('body').getAttribute('data-product-type');
        if (p_type === 'Mattresses' || p_type === 'Beds & Bed Frames') {
         gaEvent('size_confirmed', ['', '', '', '', '', ''], false);
        }
    }); 
}

function handleScroll() {
  const target = document.querySelector('.mattress-pdp-form-wrap');
  
  if (!target) {
    if (window.scrollY > 240) {
      document.body.classList.add('show-atc-button');
    } else {
      document.body.classList.remove('show-atc-button');
    }
    return;
  }
  
  const rect = target.getBoundingClientRect();
  if (rect.top <= 0) {
    document.body.classList.add('show-atc-button');
  } else {
    document.body.classList.remove('show-atc-button');
  }
}

window.addEventListener('scroll', handleScroll);
